import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// external libs
import { Observable } from 'rxjs';

// models
import { GeneralInfoFilter } from '../models/general-info-filter.model';
import { Query } from '../models/query.model';

// service
import { H21MapClusterService } from './h21-map-marker-cluster-service';


@Injectable()
export class MarkerClusterLoadService {

    public cmp: H21MapClusterService;

    constructor(
        private _http: HttpClient,
    ) { }


    public loadGeoJson(filter: Query<GeneralInfoFilter>): Observable<any[]> {
        return this._http.post<any[]>(`${this.cmp.layer.apiUrl}HotelCluster/SearchAsync`, filter);
    }

    public loadGeoJsonFilter(filter: Query<GeneralInfoFilter>): Observable<any[]> {
        return this._http.post<any[]>(`${this.cmp.layer.apiUrl}HotelCluster/SearchForOnMapAsync`, filter);
    }

    public isMarkerCluster(filter: GeneralInfoFilter): Observable<any> {
        return this._http.post<any[]>(`${this.cmp.layer.apiUrl}HotelCluster/FindClusterAsync`, filter);
    }

}
